import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';

@Injectable()
export class MrfHttpInterceptor implements HttpInterceptor {
  private isHrModuleApi(url: string): boolean {
    return (
      url.includes('/employee/api/jwtV2/mrf') ||
      url.includes('/apiV2/common') ||
      url.includes('/employee/api/jwtV2/common') ||
      url.includes('/apiV2/getLocations') ||
      url.includes('/apiV2/getStatesByLocation') ||
      url.includes('/apiV2/getCityWiseZone') ||
      url.includes('/apiV2/getDeansBySubzone') ||
      url.includes('/employee/api/jwtV2/mrf/v2/getMRFTrackHistoryWithFilters') ||
      url.includes('/employee/api/jwtV2/mrf/getCampusBudgetReportWithFilters') ||
      url.includes('/employee/api/jwtV2/mrf/v2/getCampusBudgetWithFilters') ||
      url.includes('/employee/api/jwtV2/mrf/CoustomizeFilters') ||
      url.includes('/apiV2/getCampusesByDeans')
    );
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isHrModuleApi(req.url)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((err: unknown) => {
        const status = (err as HttpErrorResponse)?.status;
        if (status === 204) {
          return of(
            new HttpResponse({
              body: null,
              status: 204,
              statusText: 'No Content',
              url: req.url,
            })
          );
        }
        return throwError(() => err);
      })
    );
  }
}
